module.exports = __webpack_public_path__ + "img/Hatchback_Front_Side_Right_Transparent.3ba9eacc.svg";